export default {
  path: '/profil',
  name: 'layoutProfil',
  component: () => import('../components/profil/Layout'),
  redirect: { name: 'Profil' },
  meta: {
    breadcrumb: 'administration.user.myprofile',
  },

  children: [
    {
      name: 'Profil',
      path: '/profil',
      component: () => import('../views/profil/Profil'),
      meta: {
        breadcrumb: 'global.view',
      },
    },
    {
      name: 'NotificationSubscriber',
      path: '/notificationsubscriber',
      component: () => import('../views/profil/NotificationSubscriber'),
      meta: {
        breadcrumb: 'menu.user.notificationsubscriber',
      },
    },
    {
      name: 'UpdateMyPassword',
      path: '/profil/updatepassword',
      component: () => import('../views/profil/UpdatePassword'),
      meta: {
        breadcrumb: 'administration.user.updatemypassword',
      },
    },
    {
      name: 'UpdateMyProfil',
      path: '/profil/updateprofil',
      component: () => import('../views/profil/Update'),
      meta: {
        breadcrumb: 'global.update',
      },
    },
  ]
};
